
import { useCallback } from 'react';
import { supabase } from '@/integrations/supabase/client';

export const useEmailRecipients = () => {
  const fetchRecipientEmails = useCallback(async (type: string): Promise<string[]> => {
    try {
      console.log(`Fetching email recipients of type: ${type}`);
      
      const { data, error } = await supabase.functions.invoke('fetch-recipient-emails', {
        body: { type }
      });
      
      if (error) {
        console.error('Error fetching recipient emails:', error);
        return [];
      }
      
      if (!data || !Array.isArray(data.emails)) {
        console.warn('No recipients found or invalid response format:', data);
        return [];
      }
      
      console.log(`Found ${data.emails.length} recipient emails for type ${type}`);
      return data.emails;
    } catch (error) {
      console.error('Error fetching recipient emails:', error);
      return [];
    }
  }, []);

  return { fetchRecipientEmails };
};
